<template>
  <v-flex
    id="history"
    class="question"
  >
    <p class="mb-0 text-uppercase">
      {{ $t('sheet.sheetOne.hint') }}
    </p>
    <h2 class="display-3 display-3_dark">
      {{ getFamilyHistoryQuestions.label }}
    </h2>
    <ul class="questions-list">
      <li
        v-if="getFamilyHistoryQuestions.hasOwnProperty('everyday_life')"
        class="mt-4"
      >
        <p
          class="header"
          :class="{ required: getFamilyHistoryQuestions.everyday_life.required }"
        >
          {{ getFamilyHistoryQuestions.everyday_life.label }}
        </p>
        <v-textarea
          v-model="everydayLife"
          v-validate="{ ...requiredRegularField(getFamilyHistoryQuestions.everyday_life.required) }"
          :placeholder="$t('placeholders.add_text')"
          :error-messages="errors.collect('everydayLife')"
          :data-vv-as="$t('label.question')"
          data-vv-name="everydayLife"
          :required="getFamilyHistoryQuestions.everyday_life.required"
          auto-grow
          :disabled="readOnly"
        />
      </li>
      <li
        v-if="getFamilyHistoryQuestions.hasOwnProperty('led_to_situation')"
        class="mt-4"
      >
        <p
          class="header"
          :class="{ required: getFamilyHistoryQuestions.led_to_situation.required }"
        >
          {{ getFamilyHistoryQuestions.led_to_situation.label }}
        </p>
        <v-textarea
          v-model="ledToSituation"
          v-validate="{
            ...requiredRegularField(getFamilyHistoryQuestions.led_to_situation.required)
          }"
          :placeholder="$t('placeholders.add_text')"
          :error-messages="errors.collect('ledToSituation')"
          :data-vv-as="$t('label.question')"
          data-vv-name="ledToSituation"
          :required="getFamilyHistoryQuestions.led_to_situation.required"
          auto-grow
          :disabled="readOnly"
        />
      </li>
      <li
        v-if="getFamilyHistoryQuestions.hasOwnProperty('life_look_like_before')"
        class="mt-4"
      >
        <p
          class="header"
          :class="{ required: getFamilyHistoryQuestions.life_look_like_before.required }"
        >
          {{ $t('sheet.sheetOne.meeting.family_history.question_3') }}
          <span
            v-if="!getFamilyHistoryQuestions.life_look_like_before.required"
            class="optional-text"
          >{{ $t('message.optional') | brackets }}</span>
        </p>
        <v-textarea
          v-model="lifeLookLikeBefore"
          v-validate="{
            ...regularLongText(getFamilyHistoryQuestions.life_look_like_before.required)
          }"
          :placeholder="$t('placeholders.add_text')"
          :error-messages="errors.collect('lifeLookLikeBefore')"
          :data-vv-as="$t('label.question')"
          data-vv-name="lifeLookLikeBefore"
          auto-grow
          :required="getFamilyHistoryQuestions.life_look_like_before.required"
          :disabled="readOnly"
        />
      </li>
      <li
        v-if="getFamilyHistoryQuestions.hasOwnProperty('to_overcome_difficulties')"
        class="mt-4"
      >
        <p
          class="header"
          :class="{ required: getFamilyHistoryQuestions.to_overcome_difficulties.required }"
        >
          {{ getFamilyHistoryQuestions.to_overcome_difficulties.label }}
        </p>
        <v-textarea
          v-model="toOvercomeDifficulties"
          v-validate="{
            ...requiredRegularField(getFamilyHistoryQuestions.to_overcome_difficulties.required)
          }"
          :placeholder="$t('placeholders.add_text')"
          :error-messages="errors.collect('toOvercomeDifficulties')"
          :data-vv-as="$t('label.question')"
          data-vv-name="toOvercomeDifficulties"
          :required="getFamilyHistoryQuestions.to_overcome_difficulties.required"
          auto-grow
          :disabled="readOnly"
        />
      </li>
    </ul>
  </v-flex>
</template>

<script>
import filters from '@/constants/filters';
import validationRules from '@/constants/validationRules';
import sheetValidationRules from '@/mixins/sheet/sheetValidationRules';

import { mapGetters } from 'vuex';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
    getterType: 'sheet/getFamilyHistoryField',
    mutationType: 'sheet/updateFamilyHistoryField'
});

export default {
    name: 'FamilyHistory',
    inject: ['$validator'],
    props: {
        readOnly: {
            default: false,
            type: Boolean
        }
    },
    computed: {
        ...mapFields([
            'everydayLife',
            'ledToSituation',
            'lifeLookLikeBefore',
            'toOvercomeDifficulties'
        ]),
        ...mapGetters('sheet', ['getFamilyHistoryQuestions'])
    },
    data () {
        return {
            validationRules
        };
    },
    filters: {
        ...filters
    },
    mixins: [sheetValidationRules]
};
</script>

<style scoped></style>
